"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAPI = void 0;
var bech32_1 = require("../../../util/bech32");
var BaseAPI = /** @class */ (function () {
    function BaseAPI(req, chains) {
        this.req = req;
        this.chains = chains;
    }
    BaseAPI.prototype.getReqFromChainID = function (chainID) {
        return this.req[chainID];
    };
    BaseAPI.prototype.getReqFromAddress = function (address) {
        var chainID = (0, bech32_1.getChainIDFromAddress)(address, this.chains);
        if (!chainID)
            throw new Error("There is no chain configured with the '".concat((0, bech32_1.getAddressPrefix)(address), "' prefix."));
        return this.req[chainID];
    };
    return BaseAPI;
}());
exports.BaseAPI = BaseAPI;
//# sourceMappingURL=BaseAPI.js.map